import { gql } from "@apollo/client";

export const PEOPLE_SEARCH_QUERY = gql`
  query PEOPLE_SEARCH_QUERY(
    $perPage: Int
    $page: Int
    $json: String
    $originatorId: ID!
  ) {
    searchPeople(
      perPage: $perPage
      page: $page
      json: $json
      originatorId: $originatorId
    ) {
      aliases {
        id
        target {
          id
          validPersonAlerts {
            alertType {
              name
              alertLevel
            }
          }
        }
      }
      id
      validPersonAlerts {
        alertType {
          id
          name
          alertLevel
        }
        createdAt
        officer {
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
      }
      personalAttribute {
        id
        organization
        lastName
        firstName
        middleName
        suffix
        gender {
          id
          name
        }
        eyeColor {
          id
          name
        }
        hairColor {
          id
          name
        }
        race {
          id
          name
        }
        height
        weight
        aliasName
        ibrArresteeRaceType {
          id
          name
        }
        dob
        phone
        juvenile
        driversLicense
        licenseState {
          id
          name
        }
        homeAddress {
          id
          validAddressAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          streetNumber
          streetName
          city
          name
        }
      }
    }
  }
`;
